export * from './list.component';
